<div class="attribute-container">
  <div class="device-table-container">
    <table #deviceAttributesTable="matSort" mat-table [dataSource]="deviceAttributes" matSort aria-label="attributes">
      <ng-container matColumnDef="attributeNum">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.attributes.header.num' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.attributeNum}}</td>
      </ng-container>
      <ng-container matColumnDef="attributeName">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.attributes.header.name' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.nameDisplayText}}</td>
      </ng-container>
      <ng-container matColumnDef="valueDisplayText">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.attributes.header.value' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.valueDisplayText}}</td>
      </ng-container>
      <ng-container matColumnDef="attributeType">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.attributes.header.type' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.attributeType}}</td>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedTimestamp">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.attributes.header.last-updated' |
          translate}}</th>
        <td mat-cell *matCellDef="let element">
          {{element.lastUpdatedTimestamp | defaultDate}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="filteredDeviceAttributesColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: filteredDeviceAttributesColumns;"></tr>
    </table>
  </div>
  <mat-paginator #deviceAttributesPaginator [pageSizeOptions]="[10, 25, 50]" [showFirstLastButtons]="!mobile"
    [hidePageSize]="mobile">
  </mat-paginator>
  <mat-button-toggle-group [multiple]="true" #deviceAttributesGroup="matButtonToggleGroup"
    [(ngModel)]="deviceAttributesColumnsToggle" class="attr-toggle">
    <mat-button-toggle value="attributeNum" class="attr-toggle-item">
      <span>{{'devices.detail.attributes.header.num' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="attributeName" class="attr-toggle-item">
      <span>{{'devices.detail.attributes.header.name' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="valueDisplayText" class="attr-toggle-item">
      <span>{{'devices.detail.attributes.header.value' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="attributeType" class="attr-toggle-item">
      <span>{{'devices.detail.attributes.header.type' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastUpdatedTimestamp" class="attr-toggle-item">
      <span>{{'devices.detail.attributes.header.last-updated' | translate}}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>